// import { Fragment } from "react";
// import Wrapper from "../components/wrapper/Wrapper";
// import Section from "../components/Section";
// import { products, discoutProducts } from "../utils/products";
// import SliderHome from "../components/Slider";
// import useWindowScrollToTop from "../hooks/useWindowScrollToTop";
// import Card from "../components/Card/Card";
// import Collection from "../components/Collection/Collection";

// const Home = () => {
//   const newArrivalData = products.filter(
//     (item) => item.category === "mobile" || item.category === "wireless"
//   );
//   const bestSales = products.filter((item) => item.category === "sofa");
//   useWindowScrollToTop();
//   return (
//     <Fragment>
//       <SliderHome />
//       <Wrapper />
//         <Card/>
//         <Collection/>
//       <Section
//         title="Big Discount"
//         bgColor="#f6f9fc"
//         productItems={discoutProducts}
//       />

//       <Section
//         title="New Arrivals"
//         bgColor="white"
//         productItems={newArrivalData}
//       />
//       <Section title="Best Sales" bgColor="#f6f9fc" productItems={bestSales} />
//     </Fragment>
//   );
// };

// export default Home;



import { Fragment } from "react";
import Wrapper from "../components/wrapper/Wrapper";
import Section from "../components/Section";
import { products, discoutProducts } from "../utils/products";
import SliderHome from "../components/Slider";
import useWindowScrollToTop from "../hooks/useWindowScrollToTop";
import Card from "../components/Card/Card";
import Collection from "../components/Collection/Collection";
import "bootstrap/dist/css/bootstrap.min.css";
import BestSelling from "../components/Bestselling/BestSelling";
import SpecialOffer from "../components/SpecialOffer/SpecialOffer";
import CustomerSay from "../components/CustomerSay/CustomerSay";
import TodaysPick from "../components/Todays/TodaysPick";
import Card2 from "../components/Card/Crad2";
import InstagramSection from "../components/CustomerSay/InstagramSection";
import Testimonials from "../components/Aboutus/TestiMonial";
import CookieConsentBanner from "../components/Modal/CookieConsentModal";
import BrandStorySection from "../components/CustomerSay/BrandStorySection";
import vantara from '../Images/vantaraicon.png';
const Home = () => {
  // const newArrivalData = products.filter(
  //   (item) => item.category === "mobile" || item.category === "wireless"
  // );
  // const bestSales = products.filter((item) => item.category === "sofa");

  useWindowScrollToTop();

  return (
    <Fragment>
     <CookieConsentBanner/>

      {/* Hero Slider */}
      <SliderHome />
      <div className="bg-white border-top border-bottom py-1 overflow-hidden">
        <div className="marquee d-flex align-items-center">
          <div className="marquee-group d-flex">
            <span className="mx-5 d-flex align-items-center black-emoji">
              <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">Visit Vantara</span>
            </span>
            <span className="mx-5 d-flex align-items-center black-emoji">
              <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">Flavours of Wayanad</span>
            </span>
            <span className="mx-5 d-flex align-items-center black-emoji">
               <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">From the house of vantara</span>
            </span>
            <span className="mx-5 d-flex align-items-center black-emoji">
              <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">Vantara</span>
            </span>
          </div>

          <div className="marquee-group d-flex">
          <span className="mx-5 d-flex align-items-center black-emoji">
              <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">Visit Vantara</span>
            </span>
            <span className="mx-5 d-flex align-items-center black-emoji">
               <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">Flavours of Wayanad</span>
            </span>
            <span className="mx-5 d-flex align-items-center black-emoji">
              <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">From the house of vantara</span>
            </span>
            <span className="mx-5 d-flex align-items-center black-emoji">
               <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">Vantara</span>
            </span>
          </div>
              <div className="marquee-group d-flex">
          <span className="mx-5 d-flex align-items-center black-emoji">
              <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">Visit Vantara</span>
            </span>
            <span className="mx-5 d-flex align-items-center black-emoji">
               <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">Flavours of Wayanad</span>
            </span>
            <span className="mx-5 d-flex align-items-center black-emoji">
              <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">From the house of vantara</span>
            </span>
            <span className="mx-5 d-flex align-items-center black-emoji">
               <img src={vantara} style={{ width: "20px", height: "20px" }} /><span className="ms-2 marquee-text">Vantara</span>
            </span>
          </div>
        </div>

        <style>{`
    .marquee {
      display: flex;
      white-space: nowrap;
      overflow: hidden;
      
    }
    .marquee-group {
      display: flex;
      animation: marquee 20s linear infinite;
    }
    @keyframes marquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-100%); }
    }
   .marquee-text {
    font-size: 0.9rem;
    font-weight: bold;
    color: black;

    .black-emoji {
  color: black;
}
  }
  `}</style>
      </div><br /><br />

     

      {/* Custom Cards Section */}
      <Card /><br />
      {/* <div style={{ backgroundColor: "#F4F4F4", width: "100%", height: "1000px" }}><br /> */}

      {/* </div> */}



      {/* Bootstrap Collection Section */}


      <TodaysPick />
      {/* <Card2/> */}
      <Collection />
      <BestSelling />
      <SpecialOffer />
          <Testimonials/>
          <BrandStorySection/>
      <CustomerSay />
      {/* Discount Section */}
      {/* <Section
        title="Big Discount"
        bgColor="#f6f9fc"
        productItems={discoutProducts}
      /> */}

      {/* New Arrivals */}
      {/* <Section
        title="New Arrivals"
        bgColor="white"
        productItems={newArrivalData}
      /> */}
      <InstagramSection />
      <hr />
      {/* Best Sales */}
      {/* <Section
        title="Best Sales"
        bgColor="#f6f9fc"
        productItems={bestSales}
      /> */}
    </Fragment>
  );
};

export default Home;
